










import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class SvgIcon extends Vue {
  @Prop({ default: "", type: String })
  private iconClass!: string;

  @Prop({ default: "", type: String })
  private className!: string;

  private get iconName() {
    return `#icon-${this.iconClass}`;
  }
  private get svgClass() {
    if (this.className) {
      return "svg-icon " + this.className;
    } else {
      return "svg-icon";
    }
  }
}
